<template>
  <!-- Main content -->
  <v-container fluid class="py-0">
    <!-- Content grid -->
    <v-row class="mt-0">
      <!-- Left column - Time clock and attendance -->
      <v-col cols="12" lg="8">
        <!-- Time clock card -->
        <v-card class="mb-6" v-if="false">
          <v-card-title>
            <v-icon left>mdi-clock-outline</v-icon>
            Time Clock
          </v-card-title>
          <v-card-text class="text-center py-8">
            <div class="text-h2 mb-4">{{ timerDisplay }}</div>
            <div>
              <v-btn
                v-if="!isClockIn"
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-uppercase
                  btn-primary
                  bg-gradient-primary
                  py-2
                  px-6
                  me-2
                  mb-2
                "
                color="#5e72e4"
                @click="clockIn"
              >
                <v-icon left>mdi-play</v-icon>
                Clock In
              </v-btn>
              <v-btn
                v-else
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-uppercase
                  btn-danger
                  bg-gradient-danger
                  py-2
                  px-6
                  me-2
                  mb-2
                "
                color="#f5365c"
                @click="clockOut"
              >
                <v-icon left>mdi-pause</v-icon>
                Clock Out
              </v-btn>
            </div>
          </v-card-text>
        </v-card>

        <!-- Today's attendance card -->
        <v-card class="mb-2 py-0">
          <v-card-title class="py-2">出席狀態</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6" md="3" class="text-center py-0">
                <div class="text-h4 green--text">
                  {{ attendanceStats.present }}
                </div>
                <div class="text-subtitle-2 grey--text">出席</div>
              </v-col>
              <v-col cols="6" md="3" class="text-center py-0">
                <div class="text-h4 amber--text">
                  {{ attendanceStats.late }}
                </div>
                <div class="text-subtitle-2 grey--text">遲到</div>
              </v-col>
              <v-col cols="6" md="3" class="text-center py-0">
                <div class="text-h4 blue--text">
                  {{ attendanceStats.early }}
                </div>
                <div class="text-subtitle-2 grey--text">早退</div>
              </v-col>
              <v-col cols="6" md="3" class="text-center py-0">
                <div class="text-h4 red--text">
                  {{ attendanceStats.absent }}
                </div>
                <div class="text-subtitle-2 grey--text">缺席</div>
              </v-col>
              <!-- <v-col cols="6" md="2" class="text-center">
                  <div class="text-h4 purple--text">{{ attendanceStats.abnormal }}</div>
                  <div class="text-subtitle-2 grey--text">異常</div>
                </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Today's Attendance Records -->
        <attendance-records
          :date="currentDate"
          @update-stats="updateAttendanceStats"
        ></attendance-records>
      </v-col>

      <!-- Right column - Calendar -->
      <v-col cols="12" lg="4">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-calendar</v-icon>
            日曆
          </v-card-title>
          <v-card-text class="pa-0 card-calendar-body">
            <full-calendar
              :options="calendarOptions"
              ref="fullCalendar"
            ></full-calendar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import AttendanceRecords from "../components/Widgets/AttendanceRecords.vue";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();

export default {
  name: "TimeTracking",
  components: {
    FullCalendar,
    AttendanceRecords,
  },
  data() {
    let monthText = m + 1 > 10 ? m + 1 : `0${m + 1}`;
    let yearAndMonth = `${y}-${monthText}`;
    return {
      isClockIn: false,
      timer: null,
      seconds: 0,
      timerDisplay: "00:00:00",
      currentDate: "",
      currentTime: "",
      clockInterval: null,
      attendanceStats: {
        present: 0,
        late: 0,
        earlyLeave: 0,
        absent: 0,
        abnormal: 0,
      },
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        contentHeight: "auto",
        headerToolbar: false,
        selectable: true,
        selectHelper: true,
        editable: true,
        dateClick: this.handleDateClick,
        events: [
          {
            title: "今日",
            start: `${yearAndMonth}-${today.getDate()}`,
            end: `${yearAndMonth}-${today.getDate()}`,
            className: "bg-green",
            allDay: true,
          },
          // {
          //   title: "Team Meeting",
          //   start: `${yearAndMonth}-10`,
          //   end: `${yearAndMonth}-10`,
          //   className: "bg-blue",
          //   allDay: true,
          // },
          // {
          //   title: "Project Deadline",
          //   start: `${yearAndMonth}-15`,
          //   end: `${yearAndMonth}-15`,
          //   className: "bg-red",
          //   allDay: true,
          // },
        ],
      },
      attendanceRecords: [],
    };
  },
  created() {
    this.updateDateTime();
    // setInterval(this.updateDateTime, 1000);
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.clockInterval) {
      clearInterval(this.clockInterval);
    }
  },
  methods: {
    clockIn() {
      this.isClockIn = true;
      this.seconds = 0;
      this.timer = setInterval(() => {
        this.seconds++;
        this.updateTimerDisplay();
      }, 1000);
    },
    clockOut() {
      this.isClockIn = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    updateTimerDisplay() {
      const hours = Math.floor(this.seconds / 3600);
      const minutes = Math.floor((this.seconds % 3600) / 60);
      const secs = this.seconds % 60;

      this.timerDisplay = [
        hours.toString().padStart(2, "0"),
        minutes.toString().padStart(2, "0"),
        secs.toString().padStart(2, "0"),
      ].join(":");
    },
    updateDateTime() {
      const now = new Date();
      // Format for API (YYYY-MM-DD)
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      this.currentDate = `${year}-${month}-${day}`;

      this.currentTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    calendarApi() {
      return this.$refs.fullCalendar.getApi();
    },
    nextMonth() {
      this.calendarApi().next();
    },
    previousMonth() {
      this.calendarApi().prev();
    },

    updateAttendanceStats(stats) {
      // Update the attendance statistics with data from the AttendanceRecords component
      // console.log("update ",stats)
      this.attendanceStats = stats;
    },

    handleDateClick(info) {
      // Format the clicked date as YYYY-MM-DD for currentDate
      const clickedDate = new Date(info.date);
      const year = clickedDate.getFullYear();
      const month = String(clickedDate.getMonth() + 1).padStart(2, "0");
      const day = String(clickedDate.getDate()).padStart(2, "0");
      this.currentDate = `${year}-${month}-${day}`;

      // You can add visual feedback for the selected date if needed
      // console.log(`Date selected: ${this.currentDate}`);
    },
  },
};
</script>
